(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.Ireland",
                {
                    url: "/Dublin",
                    component: "ireland",
                    PageTitle: "Dublin 2020",
                    requiredPermissions: "Greenbrier:View",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);

    app.component("ireland",
        {
            templateUrl: "App/Resources/Ireland/Ireland.html",
            controller: irelandCtrl,
            bindings: {
                states: "<"
            }
        });

    irelandCtrl.$inject = ["amplitudeService"];

    function irelandCtrl(amplitudeService) {
        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };
       
    }
})(window.app, window.angular); // jshint ignore:line